export const SEARCH_ELEMENT = "SEARCH_ELEMENT";
export const CATEGORY_GROUP = "CATEGORY_GROUP";
export const CATEGORY_ELEMENT = "CATEGORY_ELEMENT";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_FILTER = "SET_FILTER";
export const SET_SORT = "SET_SORT";
export const ADD_CART_PRODUCT = "ADD_PRODUCT_CART";
export const REMOVE_CART_PRODUCT = "REMOVE_CART_PRODUCT";
export const CHANGE_QUANTITY_PRODUCT = "CHANGE_QUANTITY_PRODUCT";
export const ADD_COMMENT = "ADD_COMMENT";
export const CHANGE_PRICE_TOTAL = "CHANGE_PRICE_TOTAL"
export const CLEAR_CART = "CLEAR_CART"
export const CHANGE_PP_ADJ = "CHANGE_PP_ADJ"
export const CHANGE_PP_MAT = "CHANGE_PP_MAT"
export const CHANGE_PP_OBJ = "CHANGE_PP_OBJ"
export const CHANGE_PP_COR = "CHANGE_PP_COR"
export const CHANGE_PP_CAT = "CHANGE_PP_CAT"
export const CHANGE_ADMIN_ON = "CHANGE_ADMIN_ON"